import React,{useState,useEffect} from 'react'
import Loading from '../../../common/Loading'
import {toast} from 'react-toastify'
import settingsService from '../../../../services/settings.service'
import { useEyeconxStore } from '../../../../store/eyeconxStore'
import HoursForm from './HoursForm'
import HoursText from './HoursText'

function Hours() {
     const [isEditing,setIsEditing] = useState(false)
      const [isLoading,setIsLoading] = useState(true)
      const [clinicHours,setClinicHours] = useState(null)
      const clinicId = useEyeconxStore(state => state.user.clinicId)

      useEffect(()=>{
        console.log("Getting Clinic hOurs")
            getClinicHours()
       },[clinicId])

     const getClinicHours = ()=>{
        setIsLoading(true)
        settingsService.getHours(clinicId)
        .then(res=>{
            setClinicHours(res.data)
            setIsLoading(false)
        })
        .catch(err=>{
            console.log("Error while getting Clinic Hours ")
            setIsLoading(false)
        })
     }
     
     const updateClinicHours = (data)=>{
        setClinicHours(data)
        settingsService.updateHours(clinicId,data)
        .then(res=>{
            toast.success("Updated",{
                position:"bottom-right"
            })
        })
        .catch(err=>{
            toast.error("Error While updating Clinic Hours",{
                position:"bottom-right"
            })
        })
  }
    const toogleEditing = ()=>{
        setIsEditing(!isEditing)
    }
  return (
   <>
    <div className="row mb-4">
        <div className="col-12">
                <div className="d-flex justify-content-between">
                    <h1>Clinic Hours</h1>
                    <div>
                        {isEditing?
                       <>
                        <button className="btn btn-warning me-3" onClick={()=>setIsEditing(!isEditing)}>Cancel</button>
                        
                        </>
                        :
                       
                         <button className="btn btn-icon btn-secondary" onClick={()=>setIsEditing(!isEditing)}><i className="bi bi-pencil"></i></button>
                        }
                    </div>
                      </div>
        </div>
    </div>
    <div className="separator border-2 my-5"></div>
    {  isLoading?<Loading/> : <>
        {isEditing ? <HoursForm clinicHours={clinicHours} toogleEditing={toogleEditing} updateHours={updateClinicHours}/> : <HoursText clinicHours={clinicHours} /> }
    </>}
 
   
   </>
  )
}

export default Hours